(function () {
  var fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  var debounceTimer = null;

  function debounce(fn, wait) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(fn, wait || 40);
  }

  function box() {
    return document.getElementById('caribia-outdoor-price');
  }

  // ------- Produkt / Variante -------
  function findProductJSON() {
    var el = document.querySelector('[data-section-type="static-product"][data-section-id][data-section-data]');
    if (!el) return null;
    try {
      return (JSON.parse(el.textContent || el.innerText || '{}') || {}).product || null;
    } catch (e) {
      return null;
    }
  }

  function getSelectedVariant(product) {
    var checked = document.querySelector('input[name="id"]:checked');
    if (checked) {
      var v = product.variants.find(function (x) { return String(x.id) === String(checked.value); });
      if (v) return v;
    }
    var sel = document.querySelector('select[name="id"]');
    if (sel) {
      var v2 = product.variants.find(function (x) { return String(x.id) === String(sel.value); });
      if (v2) return v2;
    }
    return product.selected_or_first_available_variant || product.variants[0];
  }

  // ------- Lieferdatum berechnen -------
  function addBusinessDays(start, count) {
    var d = new Date(start);
    var added = 0;
    while (added < count) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) added++;
    }
    return d;
  }

  function getDeliveryDateStr(minDays, maxDays) {
    var days = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
    var months = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'];
    var now = new Date();
    var earliest = addBusinessDays(now, minDays);
    var latest = addBusinessDays(now, maxDays);
    function f(d) { return days[d.getDay()] + '. ' + d.getDate() + '. ' + months[d.getMonth()]; }
    return f(earliest) + ' – ' + f(latest);
  }

  // ------- Countdown bis 14:00 -------
  function updateCountdown() {
    var el = document.querySelector('[data-cop-countdown]');
    if (!el) return;
    var now = new Date();
    var cutoff = new Date(now);
    cutoff.setHours(14, 0, 0, 0);
    if (now >= cutoff) cutoff.setDate(cutoff.getDate() + 1);
    var diff = cutoff - now;
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    el.textContent = pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
  }

  // ------- Versandstatus: dynamisch nach Betrag UND gewaehltem Land -------
  var lastPriceCents = 0;

  function getActiveCountry() {
    var btn = document.querySelector('.cop-country-btn--active');
    return btn ? (btn.getAttribute('data-cop-country') || 'DE') : 'DE';
  }

  function setShipRow(title, sub, green) {
    var titleEl = document.querySelector('[data-cop-ship-title]');
    var subEl = document.querySelector('[data-cop-ship-sub]');
    var iconEl = document.querySelector('[data-cop-ship-icon]');
    if (!titleEl || !subEl) return;
    titleEl.textContent = title;
    titleEl.className = green ? 'cop-ship-title cop-ship-title--green' : 'cop-ship-title';
    subEl.textContent = sub;
    if (iconEl) {
      iconEl.className = green ? 'cop-ship-icon cop-ship-icon--green' : 'cop-ship-icon';
      var svg = iconEl.querySelector('svg');
      if (svg) svg.setAttribute('stroke', green ? '#2a7d3a' : '#999');
    }
  }

  function updateShippingStatus(priceCents) {
    if (priceCents) lastPriceCents = priceCents;
    var country = getActiveCountry();
    if (country !== 'DE') {
      // AT + CH: Speditionsversand 199,99, keine Kostenlos-Schwelle
      setShipRow('Versand: 199,99 €', 'Speditionsversand aus Deutschland · Rückversand 30 Tage', false);
      return;
    }
    if (priceCents >= 140000) {
      setShipRow('Kostenloser Versand', 'Kostenloser Rückversand innerhalb 30 Tagen', true);
    } else if (priceCents <= 50000) {
      setShipRow('Versand: 19,95 €', 'Kostenlos ab 1.400 € · Rückversand 30 Tage', false);
    } else {
      setShipRow('Versand: 79,98 €', 'Kostenlos ab 1.400 € · Rückversand 30 Tage', false);
    }
  }

  // ------- Klarna-Betraege (Karte + Info-Fenster) -------
  // Basis: Preis NACH Juli-Rabatt (was an der Kasse tatsaechlich faellig wird)
  function getExtraCents() {
    var b = box();
    return b ? (parseInt(b.getAttribute('data-cop-extra'), 10) || 0) * 100 : 0;
  }

  function updateKlarna(priceCents) {
    var payCents = Math.max(0, priceCents - getExtraCents());
    var rate = fmt.format(Math.round(payCents / 3) / 100);
    var total = fmt.format(payCents / 100);
    var rateEl = document.querySelector('[data-cop-klarna-rate]');
    if (rateEl) rateEl.textContent = rate;
    var rate2El = document.querySelector('[data-cop-klarna-rate2]');
    if (rate2El) rate2El.textContent = rate;
    var t1El = document.querySelector('[data-cop-klarna-total1]');
    if (t1El) t1El.textContent = total;
    var t2El = document.querySelector('[data-cop-klarna-total2]');
    if (t2El) t2El.textContent = total;
    var t30El = document.querySelector('[data-cop-klarna-total30]');
    if (t30El) t30El.textContent = total;
  }

  // ------- Lieferdatum nach Land updaten -------
  function updateDeliveryDate() {
    var activeBtn = document.querySelector('.cop-country-btn--active');
    if (!activeBtn) return;
    var minDays = parseInt(activeBtn.getAttribute('data-cop-min'), 10) || 5;
    var maxDays = parseInt(activeBtn.getAttribute('data-cop-max'), 10) || 11;
    var dateEl = document.querySelector('[data-cop-delivery-date]');
    if (dateEl) dateEl.textContent = getDeliveryDateStr(minDays, maxDays);
  }

  // ------- Varianten-Kapseln: Klick auf Shopify synchronisieren -------
  function selectShopifyVariant(variantId) {
    // Radio buttons
    var radios = document.querySelectorAll('input[name="id"]');
    radios.forEach(function (r) {
      if (String(r.value) === String(variantId)) {
        r.checked = true;
        r.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    // Select dropdown
    var sel = document.querySelector('select[name="id"]');
    if (sel) {
      sel.value = String(variantId);
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }
    // Also try clicking matching option radio in the theme's option system
    var optionInputs = document.querySelectorAll('[data-variant-option-value]');
    // Trigger variant:change event
    document.dispatchEvent(new CustomEvent('variant:change'));
  }

  function updateVariantCards(activeVariantId) {
    var cards = document.querySelectorAll('[data-cop-variant-card]');
    cards.forEach(function (card) {
      if (String(card.getAttribute('data-cop-variant-id')) === String(activeVariantId)) {
        card.classList.add('cop-variant-card--active');
      } else {
        card.classList.remove('cop-variant-card--active');
      }
    });
  }

  // ------- Preis updaten -------
  function doUpdate() {
    var b = box();
    if (!b) return;
    if (!b.querySelector('.cop-box')) return;

    var product = findProductJSON();
    if (!product || !product.variants) return;

    var variant = getSelectedVariant(product);
    if (!variant) return;

    var priceCents = parseInt(variant.price, 10) || 0;
    var compareAtCents = parseInt(variant.compare_at_price, 10) || 0;

    if (!compareAtCents || compareAtCents <= priceCents) return;

    var savingsCents = compareAtCents - priceCents;

    var compareEl = b.querySelector('[data-cop-compare]');
    var finalEl = b.querySelector('[data-cop-final]');
    var saveEl = b.querySelector('[data-cop-save]');

    if (compareEl) compareEl.textContent = fmt.format(compareAtCents / 100);
    if (finalEl) finalEl.textContent = fmt.format(priceCents / 100);
    if (saveEl) saveEl.textContent = '– ' + fmt.format(savingsCents / 100);

    updateDeliveryDate();
    updateShippingStatus(priceCents);
    updateKlarna(priceCents);
    updateVariantCards(variant.id);
  }

  function update() { debounce(doUpdate, 40); }

  // ------- Beobachter -------
  var formMO = null;

  function observeVariantChanges() {
    var formEl = document.querySelector('[data-product-form]');
    if (!formEl || formMO) return;
    formMO = new MutationObserver(function () { update(); });
    formMO.observe(formEl, {
      childList: true, characterData: true, subtree: true, attributes: true
    });
  }

  // ------- Click handlers -------
  document.addEventListener('click', function (e) {
    // Variant card click
    var card = e.target.closest('[data-cop-variant-card]');
    if (card) {
      var variantId = card.getAttribute('data-cop-variant-id');
      if (variantId) {
        selectShopifyVariant(variantId);
        updateVariantCards(variantId);
        // Also update price immediately from card data
        var b = box();
        if (b) {
          var priceCents = parseInt(card.getAttribute('data-cop-variant-price'), 10) || 0;
          var compareAtCents = parseInt(card.getAttribute('data-cop-variant-compare'), 10) || 0;
          var savingsCents = compareAtCents - priceCents;
          var compareEl = b.querySelector('[data-cop-compare]');
          var finalEl = b.querySelector('[data-cop-final]');
          var saveEl = b.querySelector('[data-cop-save]');
          if (compareEl) compareEl.textContent = fmt.format(compareAtCents / 100);
          if (finalEl) finalEl.textContent = fmt.format(priceCents / 100);
          if (saveEl && savingsCents > 0) saveEl.textContent = '– ' + fmt.format(savingsCents / 100);
          updateShippingStatus(priceCents);
          updateKlarna(priceCents);
        }
      }
      return;
    }

    // Klarna-Info-Modal oeffnen/schliessen
    if (e.target.closest('[data-cop-klarna-open]')) {
      var km = document.querySelector('[data-cop-klarna-modal]');
      if (km) km.classList.add('is-open');
      return;
    }
    if (e.target.closest('[data-cop-km-close]')) {
      var kmc = e.target.closest('.cop-modal-overlay');
      if (kmc) kmc.classList.remove('is-open');
      return;
    }

    // Country switcher
    var countryBtn = e.target.closest('[data-cop-country]');
    if (countryBtn) {
      var allBtns = document.querySelectorAll('.cop-country-btn');
      allBtns.forEach(function (btn) { btn.classList.remove('cop-country-btn--active'); });
      countryBtn.classList.add('cop-country-btn--active');
      updateDeliveryDate();
      updateShippingStatus(lastPriceCents);
      return;
    }

    // Juli-Rabatt-Modal oeffnen (schliessen laeuft ueber data-cop-km-close/Overlay)
    if (e.target.closest('[data-cop-juli-open]')) {
      var jm = document.querySelector('[data-cop-juli-modal]');
      if (jm) jm.classList.add('is-open');
      return;
    }

    // Modal open
    if (e.target.closest('[data-cop-open-modal]')) {
      var modal = document.querySelector('[data-cop-modal]');
      if (modal) modal.classList.add('is-open');
      return;
    }
    // Modal close
    if (e.target.closest('[data-cop-close-modal]')) {
      var m = document.querySelector('[data-cop-modal]');
      if (m) m.classList.remove('is-open');
      return;
    }
    if (e.target.classList.contains('cop-modal-overlay')) {
      e.target.classList.remove('is-open');
    }
  });

  // ------- Events -------
  document.addEventListener('change', update);
  document.addEventListener('input', update);
  document.addEventListener('variant:change', update);
  document.addEventListener('variant:changed', update);

  document.addEventListener('DOMContentLoaded', function () {
    observeVariantChanges();
    update();
    updateCountdown();
    setInterval(updateCountdown, 1000);
  });
  window.addEventListener('load', function () {
    observeVariantChanges();
    update();
  });

  setInterval(observeVariantChanges, 1000);
})();
